import CacheStore from 'services/utils/cacheStore';
import SingletonService from 'services/utils/singletonService';
import http from 'services/utils/http';
import { parseParamsForURL } from 'services/utils/urlParams';

const apiName = 'monetizeApp';

class MonetizeApp {
    cacheMonetizeApps = CacheStore.getStore(apiName);

    cacheCVManager = CacheStore.getStore('cvManager');

    baseUrl = '/api/rest/v1/monetize';

    clearData() {
        this.cacheMonetizeApps.commit({
            type: 'clearCache',
            api: apiName
        });
        this.cacheCVManager.commit({
            type: 'clearCache',
            api: 'cvManager'
        });
    }

    // eslint-disable-next-line class-methods-use-this
    formatData(data) {
        const res = { ...data };
        res.data.applicationsMap = res.data.applications.reduce((rowData, application) => {
            const row = { ...rowData };
            row[application.appKey] = application;
            return row;
        }, {});

        return res;
    }

    // <editor-fold desc="Get">
    async getMonetizeApplications({ refresh = false, filters = { }, extraFields = '' } = {}) {
        const fields = `appKey,icon,platform,name,archived${extraFields}`;

        const filtersAndFields = { ...filters, fields };
        if (!refresh) {
            const cachedResult = this.cacheMonetizeApps.getters.getFromCache(apiName, filtersAndFields);
            if (cachedResult) {
                return cachedResult;
            }
        }

        const params = parseParamsForURL(filtersAndFields);

        const apiUrl = `${this.baseUrl}?${params}`;
        return http.get(apiUrl).then((resData) => {
            const res = this.formatData(resData);
            this.cacheMonetizeApps.commit({
                type: 'setCache',
                api: apiName,
                req: filtersAndFields,
                data: res
            });
            return res;
        });
    }

    async getMonetizeApplicationByAppKey(appKey = '') {
        if (!appKey) {
            return;
        }
        // eslint-disable-next-line max-len
        const { data } = await this.getMonetizeApplications({ refresh: true, extraFields: ',liveInStore,restrictedUsers,mediationAdUnits' });
        // eslint-disable-next-line no-prototype-builtins,consistent-return
        return data && data.applicationsMap && data.applicationsMap.hasOwnProperty(appKey)
            ? data.applicationsMap[appKey] : {};
    }

    // url "//local.supersonicads.com/api/rest/v1/monetize/updateStatus?appKey=28c0b53d"
    // http put
    // appKey
    async changeAdUnitStatus(appKey, adunitsData) {
        const apiUrl = `${this.baseUrl}/updateStatus?appKey=${appKey}`;
        return http.put(apiUrl, adunitsData).then(() => {
            this.clearData();
        });
    }
    // </editor-fold>
}

const singletonService = new SingletonService(apiName);
if (!singletonService.isInitialized()) {
    singletonService.setService(new MonetizeApp());
}

export default singletonService.getService();
